(function () {
  var els = document.querySelectorAll('[data-lx]');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
  }, { threshold: 0.15 });
  els.forEach(function (e) { io.observe(e); });
})();
// Back-to-top button: appears after scrolling past the first screen.
(function () {
  var b = document.createElement('button');
  b.className = 'ag-top'; b.type = 'button'; b.setAttribute('aria-label', 'Back to top'); b.innerHTML = '&uarr;';
  document.body.appendChild(b);
  var on = false;
  addEventListener('scroll', function () { var v = scrollY > innerHeight; if (v !== on) { on = v; b.classList.toggle('is-on', v); } }, { passive: true });
  b.addEventListener('click', function () { scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
})();
